import * as Hammer from 'hammerjs';
(window as any).Hammer = Hammer.default;

export var fliptoWeb = angular.module("fliptoWeb", [
    "ui.router",
    "mgcrea.ngStrap",
    "ngSanitize",
    "ngAnimate",
    "ngSanitize",
    "angularMoment",
    "infinite-scroll",
    "angulartics",
    "angulartics.scroll",
    "angulartics.google.analytics"
]);
